export default __webpack_public_path__ + "static/media/logoFooter.64e01ce3.svg";